import React, { useMemo } from 'react';
import { Tooth, ToothMobility } from '../../../../graphql/graphql';
import { ToothView } from '../../Enums/ToothView.enum';
import { getIconHeightPosition } from '../../Helpers/periodontal/iconHeightPosition';

interface Props {
	tooth?: Tooth;
	width: number;
	height: number;
	view: ToothView;
}

const DENTToothMobility = ({ tooth, width, height, view }: Props) => {
	if (
		!tooth?.periodontal?.mobility ||
		tooth?.periodontal?.mobility === ToothMobility.None
	) {
		return <></>;
	}

	const svgContent = useMemo(() => {
		switch (tooth.periodontal?.mobility) {
			case ToothMobility.Class_1:
				return (
					<>
						<polyline
							points='20,8 4,24 20,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='110,8 126,24 110,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
					</>
				);
			case ToothMobility.Class_2:
				return (
					<>
						<polyline
							points='20,8 4,24 20,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='38,8 22,24 38,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='92,8 108,24 92,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='110,8 126,24 110,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
					</>
				);
			case ToothMobility.Class_3:
				return (
					<>
						<polyline
							points='20,8 4,24 20,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='38,8 22,24 38,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='56,8 40,24 56,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='74,8 90,24 74,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='92,8 108,24 92,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
						<polyline
							points='110,8 126,24 110,40'
							stroke='black'
							stroke-width='6'
							fill='none'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
					</>
				);
			default:
				return null;
		}
	}, [tooth.periodontal?.mobility]);

	const furcationWidth = useMemo(() => width / 2 - 58, [width]);
	const furcationHeight = useMemo(
		() =>
			getIconHeightPosition({
				height,
				view,
				jaw: tooth.jaw,
				crownUpOffset: 0.7,
				crownDownOffset: 0.3,
			}),
		[height, view, tooth.jaw],
	);

	return (
		<g transform={`translate(${furcationWidth},${furcationHeight})`}>
			<svg width='117' height='43' viewBox='0 0 130 48'>
				{svgContent}
			</svg>
		</g>
	);
};

export default DENTToothMobility;
